import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUpload,
  faTimes,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";

const UploadManualModal = ({
  open,
  onClose,
  file,
  setFile,
  onUpload,
  loading,
}) => {
  /* ================= FILE SELECT ================= */
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);

    // allow only PDFs
    const pdfs = files.filter((f) => f.type === "application/pdf");

    if (pdfs.length === 0) return;

    setFile((prev = []) => [...prev, ...pdfs]);
  };

  /* ================= REMOVE ONE FILE ================= */
  const removeFile = (index) => {
    setFile((prev) => prev.filter((_, i) => i !== index));
  };

  /* ================= CLEAR ALL ================= */
  const clearAll = () => setFile([]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box className="bg-white w-[440px] p-5 rounded-lg mx-auto mt-[12vh] shadow-lg outline-none">

        {/* HEADER */}
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-semibold text-lg">Upload Manuals</h3>

          <button onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        {/* FILE PICKER */}
        <label className="flex flex-col items-center justify-center h-36 border-2 border-dashed mb-4 rounded cursor-pointer hover:border-black transition">
          <input
            type="file"
            accept="application/pdf"
            multiple
            onChange={handleFileChange}
            className="hidden"
          />

          <FontAwesomeIcon
            icon={faUpload}
            className="text-2xl text-gray-600 mb-2"
          />

          <p className="text-sm font-medium">
            Click to select PDF files
          </p>

          <p className="text-xs text-gray-500">
            Multiple PDF supported
          </p>
        </label>

        {/* FILE LIST */}
        {file && file.length > 0 && (
          <div className="mb-4 max-h-44 overflow-auto">
            {file.map((f, i) => (
              <div
                key={i}
                className="border rounded p-2 flex justify-between items-center mb-2"
              >
                <div className="flex items-center gap-2">
                  <FontAwesomeIcon
                    icon={faFilePdf}
                    className="text-red-600 text-lg"
                  />

                  <div>
                    <p className="text-sm">{f.name}</p>
                    <p className="text-xs text-gray-500">
                      {(f.size / 1024 / 1024).toFixed(2)} MB
                    </p>
                  </div>
                </div>

                <button
                  onClick={() => removeFile(i)}
                  className="text-red-600 text-sm"
                >
                  ✕
                </button>
              </div>
            ))}

            {/* CLEAR ALL */}
            <button
              onClick={clearAll}
              className="text-xs text-red-600 mt-1"
            >
              Remove all
            </button>
          </div>
        )}

        {/* ACTION */}
        <button
          onClick={onUpload}
          disabled={!file || file.length === 0 || loading}
          className="w-full bg-black text-white py-2 rounded flex justify-center items-center gap-2 disabled:opacity-40"
        >
          {loading && <CircularProgress size={18} color="inherit" />}
          Upload {file?.length > 0 ? `(${file.length})` : ""}
        </button>
      </Box>
    </Modal>
  );
};

export default UploadManualModal;
